import Constants from 'expo-constants';

export async function safeRemovePandaUsage(videoExternalId, removalRefs) {
  const baseUrl = 'https://api-v2.pandavideo.com.br/videos';
  const { pandaApiKey } = Constants.manifest.extra;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${pandaApiKey}`
  };

  let title;
  let rawDesc;
  // 1) Tenta GET dos metadados
  try {
    const getRes = await fetch(`${baseUrl}/${videoExternalId}`, {
      method: 'GET',
      headers
    });
    if (getRes.status === 404) {
      console.warn(`Vídeo Panda não encontrado (já deletado?): ${videoExternalId}`);
      return;
    }
    if (!getRes.ok) {
      const txt = await getRes.text();
      throw new Error(`GET Panda falhou: ${txt}`);
    }
    const json = await getRes.json();
    title   = json.title;
    rawDesc = json.description;
  } catch (e) {
    console.error(`Erro ao buscar vídeo Panda ${videoExternalId}:`, e);
    return;
  }

  // 2) parse ou inicializa meta.usages
  let meta;
  try {
    meta = JSON.parse(rawDesc);
  } catch {
    meta = { usages: [] };
  }
  const usos = Array.isArray(meta.usages) ? meta.usages : [];

  // 3) filtra todos os removalRefs
  const filtered = usos.filter(u =>
    !removalRefs.some(ref =>
      ref.categoryId === u.categoryId &&
      ref.cardId      === u.cardId &&
      ref.videoId     === u.videoId
    )
  );

  // 4) Se não sobrou uso, tenta DELETE; se 404, só warning
  if (filtered.length === 0) {
    try {
      const delRes = await fetch(`${baseUrl}/${videoExternalId}`, {
        method: 'DELETE',
        headers
      });
      if (delRes.status === 404) {
        console.warn(`Vídeo Panda já não existe para deletar: ${videoExternalId}`);
        return;
      }
      if (!delRes.ok) {
        const txt = await delRes.text();
        throw new Error(`DELETE Panda falhou: ${txt}`);
      }
      console.log(`🗑️ Vídeo Panda deletado: ${videoExternalId}`);
    } catch (e) {
      console.error(`Erro ao deletar vídeo Panda ${videoExternalId}:`, e);
    }
  } else {
    // 5) Ainda há usos → PUT só description
    try {
      const body = {
        title,
        description: JSON.stringify({ ...meta, usages: filtered })
      };
      const putRes = await fetch(`${baseUrl}/${videoExternalId}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(body)
      });
      if (putRes.status === 404) {
        console.warn(`Vídeo Panda não encontrado para atualizar metadata: ${videoExternalId}`);
        return;
      }
      if (!putRes.ok) {
        const txt = await putRes.text();
        throw new Error(`PUT Panda falhou: ${txt}`);
      }
      console.log(`Metadata Panda atualizado em ${videoExternalId}:`, filtered);
    } catch (e) {
      console.error(`Erro ao atualizar metadata de vídeo Panda ${videoExternalId}:`, e);
    }
  }
}
